import React from "react";
import { EditorContent } from "@tiptap/react";
import useUniversalTipTap from "./useUniversalTipTap";

import LinkModal from "./components/LinkModal";
import UniversalTipTapMenubar from "./components/UniversalTipTapMenubar";

import cx from "classnames";

const UniversalTipTap = (props) => {
  const {
    drawerFooter,
    isNovaFooter,
    link,
    bold,
    italic,
    underline,
    bulletList,
    orderedList,
    dir,
    h1,
    h2,
    h3,
    urlPlaceholder,
    textPlaceholder,
    insertLink,
    done,
  } = props;

  const {
    editor,
    isEditable,
    editorClass,
    menubarClass,
    editorContainerClass,
    menubarPosition,
    linkModalClass,
    getSelectedText,
    setLink,
    showLinkModal,
    setShowLinkModal,
    linkState,
    setLinkState,
    textToDisplay,
    setTextToDisplay,
    showTextActions,
    showBulletLists,
    showLink,
    showHeadingActions,
    onKeyDown,
  } = useUniversalTipTap(props);

  if (!editor) {
    return null;
  }

  return (
    <div className={editorContainerClass}>
      <LinkModal
        linkModalClass={linkModalClass}
        showLinkModal={showLinkModal}
        setShowLinkModal={setShowLinkModal}
        getSelectedText={getSelectedText}
        linkState={linkState}
        setLinkState={setLinkState}
        setLink={setLink}
        textToDisplay={textToDisplay}
        setTextToDisplay={setTextToDisplay}
        dir={dir}
        urlPlaceholder={urlPlaceholder}
        textPlaceholder={textPlaceholder}
        insertLink={insertLink}
        done={done}
      />
      <div
        className={cx("flex flex-col", {
          "flex-rcol": menubarPosition !== "bottom",
          "mb-40": isNovaFooter,
        })}
      >
        <EditorContent
          className={`${editorClass}`}
          editor={editor}
          onKeyDown={onKeyDown}
        />
        {isEditable && (
          <div className="flex justify-between">
            <UniversalTipTapMenubar
              className={menubarClass}
              editor={editor}
              setShowLinkModal={setShowLinkModal}
              showTextActions={showTextActions}
              showBulletLists={showBulletLists}
              showLink={showLink}
              showHeadingActions={showHeadingActions}
              link={link}
              bold={bold}
              italic={italic}
              underline={underline}
              bulletList={bulletList}
              orderedList={orderedList}
              h1={h1}
              h2={h2}
              h3={h3}
            />
            {drawerFooter}
          </div>
        )}
      </div>
    </div>
  );
};

UniversalTipTap.displayName = "UniversalTipTap";

export default UniversalTipTap;
